/**
 * This store is responsible for holding information about
 * images being uploaded
 */
import AppDispatcher from '../dispatcher/app-dispatcher'
import assign from 'lodash/assign'
import debounce from "lodash/debounce"
import noop from "lodash/noop"
import isUndefined from "lodash/isUndefined"

const EventEmitter = require('events').EventEmitter
const CHANGE_EVENT = 'change';


var uploadData = {
    totalImagesToUpload: 0,
    totalImagesUploaded: 0,
    totalImagesFailed: 0,
    totalImagesRegistered: 0,
    serverData: 0,
    uploadStarted: false,
    uploadErrors: [],
    uploadWarnings: {},
    browserOffline: false,
};

//If the device loose internet connection, update the store and emit a change
window.addEventListener("offline", function () {
    uploadData.browserOffline = true;
    UploadStore.emitChange();
}, false);

//If the device regains internet connection, update the store and emit a change
window.addEventListener("online", function () {
    uploadData.browserOffline = false;
    UploadStore.emitChange();
}, false);


function addUploadError(error) {
    uploadData.uploadErrors.push(error);
}

function addUploadWarning(imageId, warning) {
    if (!uploadData.uploadWarnings.hasOwnProperty(imageId)) {
        uploadData.uploadWarnings[imageId] = [];
    }
    uploadData.uploadWarnings[imageId].push(warning);
}

function removeUploadError(index) {
    uploadData.uploadErrors.splice(index, 1);
}

function updateStatisics(stats) {
    uploadData.totalImagesToUpload = stats.total;
    uploadData.totalImagesUploaded = stats.uploaded;
    uploadData.totalImagesFailed = stats.failed;
    uploadData.uploadStarted = true;
    uploadData.serverData = stats.serverData;
}

function incrementRegisterCount () {
    uploadData.totalImagesRegistered++;
}

var UploadStore = assign({}, EventEmitter.prototype, {
    /**
     * This is a proxy-wrapped method
     */
    emitChangeDebounced: noop,

    dispatcherIndex: AppDispatcher.register(function (payload) {
        var action = payload.action;
        switch (action.actionType) {
            case 'addUploadError':
                addUploadError(action.error);
                UploadStore.emitChange();
                break;
            case 'removeUploadError':
                removeUploadError(action.index);
                UploadStore.emitChange();
                break;
            case 'updateStatistics':
                updateStatisics(action.statistics);
                UploadStore.emitChange();
                break;
            case 'incrementRegisterCount':
                incrementRegisterCount();
                UploadStore.emitChange();
                break;
            case 'addUploadWarning':
                addUploadWarning(action.imageId, action.warning);
                UploadStore.emitChange();
                break;
        }
        return true;
    }),
    getData: function () {
        return uploadData;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.addListener(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

/**
 * Operation is expensive. We can skip it sometimes using "debounce"
 * @type {Function}
 */
UploadStore.emitChangeDebounced = debounce(UploadStore.emitChange.bind(UploadStore), 50);

export default UploadStore;
